import { useEffect, useState } from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import { Plus, FileDown, Grip, Tally2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import CustomCard from "../../../../components/backoffice/all-staff/card";
import Layout2 from "../../../../components/Layout/Layout2";
import LeftBar2 from "../../../../components/Layout/LeftBar2";
import { backofficeLinks } from "../../../../components/lib/SidebarLinks";
import { FaUser, FaUserCheck, FaUserXmark } from "react-icons/fa6";
import { AllStaffTable } from "@/components/backoffice/all-staff/AllStaffTable";
import StaffTableSkeleton from "@/components/skeleton/Staff-skeletion";
import Paginat from "@/components/lib/paginat";
import { Link } from "react-router-dom";
import {
  getAllStaff,
  staffSearch,
  getStaffStatistics,
} from "@/api/new-api/staff-management/staff/staff";
import OnlyTableSekeleton from "@/components/skeleton/only-table-skeleton";
import { useFilter } from "@/hooks/useFilter";
import useAuth from "@/hooks/useAuth";
import { toast } from "react-hot-toast";
import hasPermission from "@/hooks/hasPermission";

function AllStaff() {
  const { user } = useAuth();
  const [allStaffData, setAllstaffData] = useState([]);
  const [staffStatistics, setStaffStatistics] = useState(null);
  const [pagination, setPagination] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [query, setQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [filters, setFilters] = useState({
    "user.status": "",
    designation: "",
  });

  const activeData = query.trim() ? searchResults : allStaffData;
  const filteredData = useFilter(activeData, filters, {
    delay: 300,
  });
  useEffect(() => {
    const fetchAllStaff = async () => {
      try {
        setSearchLoading(true);
        const res = await getAllStaff(perPage, currentPage);
        if (res.status === "success") {
          setAllstaffData(res?.data?.allStaff || []);
          setPagination(res?.data?.pagination);
        }
      } catch (err) {
        console.error("Error fetching staff:", err);
      } finally {
        setSearchLoading(false);
      }
    };

    fetchAllStaff();
  }, [currentPage, perPage]);

  const fetchStats = async () => {
    if (!user?.restaurant_id) return;
    try {
      const res = await getStaffStatistics(user?.restaurant_id);
      setStaffStatistics(res?.data || {});
    } catch (err) {
      console.error("Error fetching stats:", err);
    }
  };

  useEffect(() => {
    fetchStats();
  }, [user?.restaurant_id]);

  useEffect(() => {
    if (query.trim()) {
      setSearchLoading(true);
    }

    const delayDebounce = setTimeout(() => {
      if (query.trim()) {
        handleSearch(query);
      } else {
        setSearchResults([]);
        setSearchLoading(false);
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [query]);

  const handleSearch = async (text) => {
    setSearchLoading(true);
    try {
      const res = await staffSearch({
        restaurantId: user?.restaurant_id,
        first_name: text,
      });

      if (res?.status === "success") {
        setSearchResults(res?.data?.staff);
      } else {
        setSearchResults([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setSearchLoading(false);
    }
  };

  if (loading) {
    return <StaffTableSkeleton links={backofficeLinks} />;
  }

  return (
    <Layout2
      LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}
      pageName={{ title: "All Staff" }}
      paths={[
        { name: "Back Office", path: "/backoffice/overview" },
        {
          name: "Staff Management",
          path: "/backoffice/staff-management/staff/all",
        },
        { name: "All Staff", path: "/backoffice/staff-management/staff/all" },
      ]}
    >
      <div className="container flex flex-col gap-4 mt-5">
        <div className="flex justify-between items-start md:items-center md:flex-row flex-col gap-5  w-full">
          <div className="flex gap-5 text-white">
            {/* <Select className="">
              <SelectTrigger className="w-[110px] border-gray-600">
                <SelectValue placeholder="Business" />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  <SelectLabel>Name</SelectLabel>
                  <SelectItem value="apple">XYZ</SelectItem>
                  <SelectItem value="banana">ABS</SelectItem>
                </SelectGroup>
              </SelectContent>
            </Select>
            <Select>
              <SelectTrigger className="w-[110px]">
                <SelectValue placeholder="Location" />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  <SelectLabel>Name</SelectLabel>
                  <SelectItem value="apple">Khulna</SelectItem>
                  <SelectItem value="banana">Dhaka</SelectItem>
                </SelectGroup>
              </SelectContent>
            </Select>
            <Select>
              <SelectTrigger className="w-[110px]">
                <SelectValue placeholder="Outlet" />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  <SelectLabel>Name</SelectLabel>
                  <SelectItem value="apple">Bonoul</SelectItem>
                  <SelectItem value="banana">Tunig star</SelectItem>
                </SelectGroup>
              </SelectContent>
            </Select> */}
          </div>
          {
            hasPermission("back_office.staff_management.add_staff") && (
              <Link to="/backoffice/staff-management/staff/add">
                <Button className="bg-cyellow hover:bg-cyellow text-black">
                  <Plus className="mr-2 h-4 w-4" />
                  Add New Staff
                </Button>
              </Link>
            )
          }

        </div>

        <div className=" w-full flex flex-wrap gap-4 justify-between items-center ">
          <CustomCard
            name="Total Staff"
            count={staffStatistics?.total_staff}
            icon={<FaUser />}
            className=" text-color6"
          />
          <CustomCard
            name="Active Staff "
            count={staffStatistics?.active_staff}
            icon={<FaUserCheck />}
            className=" text-cgreen"
          />
          <CustomCard
            name="Inactive Staff"
            count={staffStatistics?.inactive_staff}
            icon={<FaUserXmark />}
            className=" text-cred"
          />
          <CustomCard
            name="Joined this month"
            count={staffStatistics?.total_joined_in_last_30_days}
            icon={<FaUserXmark />}
            status={false}
            className=" text-cyan-700"
          />
        </div>
        <Card className="bg-cblack3 border-0">
          <CardContent className="flex justify-between flex-col gap-5 items-center mt-4">
            <div className="w-full flex justify-between lg:flex-row flex-col gap-5 items-start lg:items-center">
              <div className="flex justify-between items-center gap-3">
                <div className="grid w-full max-w-sm items-center gap-1.5">
                  <Label className="text-base text-white" htmlFor="">
                    Search Staff
                  </Label>
                  <Input
                    className="text-gray-300"
                    type="text"
                    id=""
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    placeholder="Search by Name"
                  />
                </div>
                <div className="grid w-full max-w-sm items-center gap-1.5">
                  <Label className="text-base text-white" htmlFor="">
                    Designations
                  </Label>
                  <Select
                    onValueChange={(value) =>
                      setFilters((prev) => ({
                        ...prev,
                        designation: value === "0" ? "" : value,
                      }))
                    }
                  >
                    <SelectTrigger className="w-[200px]">
                      <SelectValue placeholder="Search by Designation" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectGroup>
                        <SelectItem value="0">All</SelectItem>
                        <SelectItem value="Manager">Manager</SelectItem>
                        <SelectItem value="Staff">Staff</SelectItem>
                        <SelectItem value="Helper">Helper</SelectItem>
                        <SelectItem value="Cleaner">Cleaner</SelectItem>
                      </SelectGroup>
                    </SelectContent>
                  </Select>
                </div>
                <div className="grid w-full max-w-sm items-center gap-1.5">
                  <Label className="text-base text-white" htmlFor="">
                    Status
                  </Label>
                  <div className="relative">
                    <Select
                      onValueChange={(value) =>
                        setFilters((prev) => ({
                          ...prev,
                          "user.status": value === "0" ? "" : value,
                        }))
                      }
                    >
                      <SelectTrigger className="w-[110px]">
                        <SelectValue placeholder="Status" />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="0">All</SelectItem>
                        <SelectItem value="active">Active</SelectItem>
                        <SelectItem value="inactive">Archived</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                </div>
              </div>
              <div className="flex flex-col  gap-1.5 justify-end items-end">
                <h3 className="text-color7">
                  Total Staff: {staffStatistics?.total_staff || "0"}
                </h3>
                <div className="flex gap-3 justify-center items-center">
                  <Button className="bg-cblack5 border border-gray-600 text-white">
                    <FileDown /> Export
                  </Button>
                  <span className="text-white">
                    <Grip size={26} />
                  </span>
                  <span className="text-cyellow rotate-90 mt-2">
                    <Tally2 size={25} />
                  </span>
                  <div className="flex gap-1 justify-center items-center">
                    <h3 className="text-white">Show</h3>
                    <Select
                      onValueChange={(value) => setPerPage(Number(value))}
                      value={perPage.toString()}
                    >
                      <SelectTrigger className="w-[60px]">
                        <SelectValue placeholder="10" />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectGroup>
                          <SelectItem value="10">10</SelectItem>
                          <SelectItem value="20">20</SelectItem>
                          <SelectItem value="40">40</SelectItem>
                        </SelectGroup>
                      </SelectContent>
                    </Select>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full">
              {searchLoading ? (
                <OnlyTableSekeleton header={false} />
              ) : (
                <AllStaffTable
                  setTableData={setAllstaffData}
                  tableData={filteredData}
                  refreshStats={fetchStats}
                />
              )}

              <Paginat
                className="mt-2"
                pagination={pagination}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
          </CardContent>
        </Card>
      </div>
    </Layout2>
  );
}

export default AllStaff;
